<template v-bind:is="currentTabComponent" >

    <!--
    <spinner v-if="!loaded" ></spinner>
    -->

    <div  >
        
        <div class="row no-gutters pb-2" >
            <div class="col-8 col-md-6" >
                <h1 class="h1 font-900"> Today's conversions </h1>
            </div>
            <div class="col-4 col-md-6 text-right" style="line-height: 34px;"  >
                Refresh: 
                <a @click="getTodaySales" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
            </div>
        </div>
        
        <spinner v-if="!loaded" ></spinner>
        <div class="row atlass-grid no-gutters" v-else-if="loaded" >
            
            <div class="col-12 col-md-5" >
                <chartBlock :HEIGHT="105" :data="rows" CHART="today-gross-revenue" TITLE="Gross volume" symbol='$' sumType="progressive" ></chartBlock>
            </div>
            
            <div class="col-12 col-md-5" >
                <chartBlock :HEIGHT="105" :data="rows" CHART="today-sales-count" TITLE="New Conversions" sumType="progressive" ></chartBlock>
            </div>
            <div class="col-12 col-md-2" >
                <div class="col-12 pt-3 pb-3 border-bottom-gray align-middle" >
                    <a @click="fModalOpen(todaySales)" class="font-700" style="line-height:60px;" > See Today's <font-awesome-icon :icon="['fas', 'arrow-circle-right']" ></font-awesome-icon> </a>
                </div>
                <div class="col-12 pt-3 pb-3 align-middle" >
                    <a @click="fModalOpen(yesterdaySales)" class="font-700" style="line-height:60px;" > See Yesterday's <font-awesome-icon :icon="['fas', 'arrow-circle-right']" ></font-awesome-icon> </a>
                </div>
            </div>
            
        </div>

        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" ></modal>
        
    </div>
</template>

<script>
import {_} from 'vue-underscore';

import firebase from "firebase";
import Cookies from 'js-cookie'
import chartBlock from '@/components/chartBlock.vue'   
import moment from 'moment'    
import helper from '@/helpers/helpers.js';
import modal from '@/components/modal.vue'    

export default {
    name: 'analyzeToday',
    props: {
        
    },
    components:{
        chartBlock,
        modal
    },
    data: function(){
        return {
            loaded: false,
            rows: [],
            todaySales: [],
            yesterdaySales: [],
            rowsYesterday: [],
            NumberOfVisitors: 0,
            CVR: 0,
            
            modalData: null,
            modalState: false,
            modalComponent: null,
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        this.getTodaySales();
        
    },
    beforeDestroy() {
    },
    methods: {
        getTodaySales: function(){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let timezone = helper.getAccountTimezone()
            
            let today = moment().tz( timezone ).startOf('day').tz('UTC')
            let startOfDay = moment().tz( timezone ).subtract(1, 'days' ).startOf('day').tz('UTC')
            //let endOfDay = moment().endOf('day').format( 'DD/MM/YYYY HH:mm' )
            let endOfDay = moment().tz( timezone ).endOf('day')

            //console.log( timezone + " | " + startOfDay.format( 'DD/MM/YYYY HH:mm' ) + " - " + endOfDay.format( 'DD/MM/YYYY HH:mm' ) )
            
            let startOfDay_unix = startOfDay.unix()
            //let endOfDay_unix = moment().endOf('day').unix()
            //console.log( startOfDay_unix )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/orders').where('datetime', '>=', startOfDay_unix ).orderBy('datetime', 'asc')

            this.todaySales = []
            this.yesterdaySales = []
            return ref.get()
                .then((snapshot) => {
                    let results = [];
                
                
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                
                                item.price = parseFloat(item.price)
                                
                                //console.log(item)
                                if( item.email != '' ){
                                    results.push(item);
                                    
                                    
                                    if( item.datetime >= today.unix() ){
                                        this.todaySales.push( item )
                                    }else{
                                        this.yesterdaySales.push( item )
                                    }
                                    
                                }
                                     
                                
                                //results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results
                                //console.log( results )
                                //this.attribution_LastClick( item )
                                
                                return results; 
                                
                        })
                        
                    )
                    .then(results => {           
                        //console.log( results )
                        //this.getTodaysVisitors()
                        
                        this.loaded = true;
                        return results;   
                        
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        fModalOpen( data, component = "orders" ){
            
            if( data.length > 0 ){
                this.modalData = data
                this.modalComponent = component
                this.modalState = true
            }else{
                this.$toast.error({
                    title:'Warning',
                    message:  'There are no sales to list'
                })
            }
                
            
        },
        
        getTodaysVisitors: function(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            //let startOfDay = moment().subtract(1, 'days').startOf('day').format( 'DD/MM/YYYY HH:mm' )
            let startOfDay = moment().startOf('day').format( 'DD/MM/YYYY HH:mm' )
            let endOfDay = moment().endOf('day').format( 'DD/MM/YYYY HH:mm' )
            
            //console.log( startOfDay + " - " + endOfDay )
            
            //let startOfDay_unix = moment().subtract(1, 'days').startOf('day').unix()
            let startOfDay_unix = moment().startOf('day').unix()
            let endOfDay_unix = moment().endOf('day').unix()
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads').where('datetime', '>=', startOfDay_unix )

            return ref.get()
                .then((snapshots) => {
                    //console.log( snapshots )
                    this.NumberOfVisitors = snapshots.size
                
                    this.calculateCVR()
                })
            
        },
        calculateCVR: function(){
            
            //exclude sales from API
            //console.log(this.rows)
            let unique = this.rows.map(item => item.leadID).filter((value, index, self) => self.indexOf(value) === index)
            //console.log( "Unique: "+unique.length )
            //console.log( "NumberOfVisitors: "+this.NumberOfVisitors )
            if( this.NumberOfVisitors > 0 && unique.length > 0  ){
                this.CVR = (unique.length) * 100 / this.NumberOfVisitors;
            }
            
        },

        
    },
    computed: {
    },
    watch: {
 
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/analyzeToday.vue